import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "unknown-resource-icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_resource_icon = _resolveComponent("resource-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["resource-card", [
      `resource-card-${_ctx.resource ? _ctx.resource.toLowerCase() : 'unknown'}`,
      { disabled: _ctx.disabled },
    ]])
  }, [
    (!_ctx.noIcon)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.resource)
            ? (_openBlock(), _createBlock(_component_resource_icon, {
                key: 0,
                resource: _ctx.resource
              }, null, 8, ["resource"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_1, "R"))
        ], 64))
      : _createCommentVNode("", true)
  ], 2))
}